// This file was auto-generated by 'typesafe-i18n'. Any manual changes will be overwritten.
// @ts-check
/* eslint-disable */

/**
 * @typedef { import('typesafe-i18n/react').ReactInit<Locales, Translations, TranslationFunctions> } ReactInit
 * @typedef { import('typesafe-i18n/react').I18nContextType<Locales, Translations, TranslationFunctions> } I18nContextType
 * @typedef { import('./i18n-types').Formatters } Formatters
 * @typedef { import('./i18n-types').Locales } Locales
 * @typedef { import('./i18n-types').TranslationFunctions } TranslationFunctions
 * @typedef { import('./i18n-types').Translations } Translations
 */

import { useContext } from 'react'
import { initI18nReact } from 'typesafe-i18n/react'

import { loadedFormatters, loadedLocales } from './i18n-util'

/** @type { ReactInit } */
const { component: TypesafeI18n, context: I18nContext } = initI18nReact(loadedLocales, loadedFormatters)

/** @type { () => I18nContextType } */
const useI18nContext = () => useContext(I18nContext)

export { I18nContext, useI18nContext }

export default TypesafeI18n
